/* eslint-disable */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "../../_components/antd.css";
import { Table, Tooltip } from "antd";
import FeatherIcon from "feather-icons-react";
import { onShowSizeChange } from "../../_components/paginationfunction";
import AddVendor from "../../customers/vendors/addVendor";

const Quotations = () => {
  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);
  const user = window.CURRENT_USER;

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchQuotations();
  }, []);

  const fetchQuotations = async () => {
    try {
      setLoading(true);
      const response = await fetch("/invoice/proforma-invoice-list/");

      if (!response.ok) {
        throw new Error("Failed to fetch quotations");
      }

      const data = await response.json();
      setQuotations(data);
    } catch (error) {
      console.error("Error fetching quotations:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Proforma ID",
      dataIndex: "proforma_number",
      sorter: (a, b) => a.proforma_number.localeCompare(b.quote_number),
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      render: (text, record) => (
        <div>
          <h2 className="table-avatar">{text}</h2>
        </div>
      ),
    },
    {
      title: "Proforma Date",
      dataIndex: "proforma_date",
      sorter: (a, b) => new Date(a.proforma_date) - new Date(b.proforma_date),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      sorter: (a, b) => a.subject.localeCompare(b.subject),
    },
    {
      title: "Total Amount",
      dataIndex: "total",
      render: (text, row) => {
        return (
          <span>
            {window.COMPANY.currency_symbol} {text}
          </span>
        );
      },
      sorter: (a, b) => parseFloat(a.total) - parseFloat(b.total),
    },
    {
      title: "Action",
      dataIndex: "Action",
      render: (_, record) => (
        <div>
          <div className="d-flex align-items-center">
            <Tooltip title="Download Proforma">
              <a
                href={`/invoice/proforma-invoices/${record.id}/download/`}
                target=""
                rel="noopener noreferrer"
                className="btn-action-icon me-2"
              >
                <FeatherIcon icon="download" size={16} />
              </a>
            </Tooltip>
            <Link
              to="#"
              className="btn-action-icon"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v" />
            </Link>
            <Link
              className="dropdown-item"
              to={`/invoice/${record.id}/edit-proforma-invoices/`}
            >
              <i className="far fa-eye me-2" />
              Edit
            </Link>
            <div className="dropdown dropdown-action">
              <Link
                to="#"
                className="btn-action-icon"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v" />
              </Link>
              <Link
                className="dropdown-item"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#delete_modal"
              >
                <i className="far fa-trash-alt me-2" />
                Delete
              </Link>
            </div>
          </div>
        </div>
      ),
    },
  ];

  // Track which proforma to delete
  const [deleteId, setDeleteId] = useState(null);

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      setLoading(true);
      const response = await fetch(
        `/invoice/proforma-invoices-delete/${deleteId}/`,
        {
          method: "DELETE",
          headers: {
            "X-CSRFToken": document.cookie
              .split("; ")
              .find((row) => row.startsWith("csrftoken="))
              ?.split("=")[1],
          },
        }
      );
      if (!response.ok) throw new Error("Failed to delete proforma");
      fetchQuotations();
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
      setDeleteId(null);
    }
  };

  // Update Action column to set deleteId
  const columnsWithDelete = columns.map((col) =>
    col.dataIndex === "Action"
      ? {
          ...col,
          render: (_, record) => (
            <div>
              <div className="d-flex align-items-center">
                <Tooltip title="Download Proforma">
                  <a
                    href={`/invoice/proforma-invoices/${record.id}/download/`}
                    target=""
                    rel="noopener noreferrer"
                    className="btn-action-icon me-2"
                  >
                    <FeatherIcon icon="download" />
                  </a>
                </Tooltip>
                <Tooltip title="View Proforma" placement="top">
                  <a
                    href={`/invoice/proforma-invoices/${record.id}/download?debug=1`}
                    className="btn-action-icon"
                    title="View Proforma"
                  >
                    <FeatherIcon icon="eye" className="me-2" />
                  </a>
                </Tooltip>
                {user?.user_role !== "customer" && (
                  <Tooltip title="Edit Proforma">
                    <Link to={`/invoice/${record.id}/edit-proforma-invoices/`}>
                      <i className="far fa-edit me-2" />
                    </Link>
                  </Tooltip>
                )}
                {user?.user_role !== "customer" && (
                  <Tooltip title="Delete Proforma">
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      onClick={() => setDeleteId(record.id)}
                    >
                      <i className="far fa-trash-alt me-2" />
                    </Link>
                  </Tooltip>
                )}
              </div>
            </div>
          ),
        }
      : col
  );

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header">
                <h5>Proforma</h5>
                <div className="list-btn">
                  <ul className="filter-list">
                    {user?.user_role !== "customer" && (
                      <li>
                        <Link
                          className="btn btn-primary"
                          to="/invoice/add-proforma-invoices"
                        >
                          <i
                            className="fa fa-plus-circle me-2"
                            aria-hidden="true"
                          />
                          Create Proforma
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            {/* Search Filter */}
            <div id="filter_inputs" className="card filter-card">
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-sm-6 col-md-3">
                    <div className="input-block mb-3">
                      <label>Name</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-3">
                    <div className="input-block mb-3">
                      <label>Email</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-3">
                    <div className="input-block mb-3">
                      <label>Phone</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Search Filter */}
            {/* Table */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card-table">
                  <div className="card-body purchase">
                    <div className="table-responsive table-hover">
                      {loading ? (
                        <div className="text-center">Loading quotations...</div>
                      ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                      ) : (
                        <Table
                          pagination={{
                            total: quotations.length,
                            showTotal: (total, range) =>
                              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                            onShowSizeChange: onShowSizeChange,
                          }}
                          columns={columnsWithDelete}
                          dataSource={quotations}
                          rowKey="id"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AddVendor setShow={setShow} show={show} />

        <div
          className="modal custom-modal fade"
          id="delete_modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
              <div className="modal-body">
                <div className="form-header">
                  <h3>Delete Proforma</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div className="modal-btn delete-action">
                  <div className="row">
                    <div className="col-6">
                      <button
                        type="button"
                        className="w-100 btn btn-primary paid-continue-btn"
                        onClick={handleDelete}
                        data-bs-dismiss="modal"
                        disabled={loading}
                      >
                        Delete
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="w-100 btn btn-primary paid-cancel-btn"
                        onClick={() => setDeleteId(null)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Quotations;
